import React from 'react'
import { Typography, Box } from '@mui/material'

export default function Title({ title }) {
  return (
    <Box sx={{ textAlign: 'center', mt: 1 }}>
      <Typography variant="h4" component="h1">
        {title}
      </Typography>
    </Box>
  )
}
